import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { MockHook } from '@jupiterone/jupiter-web-toolkit';
import useInAppNotifications from 'navbar/src/notifications/hooks/useInAppNotifications';
import { generateMockNotifications } from 'navbar/src/notifications/graphql/generateMockNotifications';

const getRelativeActionLink = (actionLink: string) =>
  actionLink.split('jupiterone.io')[1];

const useNotificationsDrawerLogic = () => {
  const history = useHistory();
  const {
    notifications,
    unreadNotifications,
    loading,
    refetch,
    handleReadNotification,
    handleReadAllUnreadNotifications,
  } = useInAppNotifications();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    !isDrawerOpen && handleReadAllUnreadNotifications();
  }, [isDrawerOpen]);

  const handleNotificationClick = (
    notificationId: string,
    actionLink: string
  ) => {
    void handleReadNotification(notificationId);
    history.push(getRelativeActionLink(actionLink));
    setIsDrawerOpen(false);
  };
  const handleClose = () => setIsDrawerOpen(false);
  const toggleDrawer = () => setIsDrawerOpen((isOpen) => !isOpen);

  return {
    loading,
    isDrawerOpen,
    notifications,
    unreadNotifications,
    refetch,
    handleClose,
    toggleDrawer,
    handleNotificationClick,
  };
};

export type NotificationsComponentProps = ReturnType<
  typeof useNotificationsDrawerLogic
>;
const MOCK_NOTIFICATIONS = generateMockNotifications();

export const MOCK_NOTIFICATIONS_DRAWER_PROPS: NotificationsComponentProps = {
  loading: false,
  isDrawerOpen: true,
  notifications: MOCK_NOTIFICATIONS,
  unreadNotifications: [MOCK_NOTIFICATIONS[0]],
  refetch: MockHook.mockFunction,
  handleNotificationClick: MockHook.mockFunction,
  toggleDrawer: MockHook.mockFunction,
  handleClose: MockHook.mockFunction,
};

export default MockHook.useMockHook(
  useNotificationsDrawerLogic,
  MOCK_NOTIFICATIONS_DRAWER_PROPS
);
